<template>
    <div class="tags ml-3" v-show="enabledAtLeastOneFilter">
        <span class="mr-2 mb-2">{{ translate("admin_payments.enabled_filters") }}</span>
        <span v-if="store.deleted" class="tag is-danger">
            {{ translate("admin_payments.filter_deleted") }}
        </span>
        <span v-if="store.showDisqualified" class="tag is-warning">
            {{ translate("admin_payments.filter_disqualified") }}
        </span>
        <span v-if="store.onlyMissingPayments" class="tag is-danger">
            {{ translate("admin_payments.full_filter.missing_payments") }}
        </span>
        <span v-if="store.onlyCompletePayments" class="tag is-success">
            {{ translate("admin_payments.full_filter.complete_payments") }}
        </span>
        <span v-if="store.paymentConfirmationFilter === 'withConfirmation'" class="tag is-info">
            {{ translate("admin_payments.full_filter.with_payment_confirmation") }}
        </span>
        <span v-if="store.paymentConfirmationFilter === 'withoutConfirmation'" class="tag is-warning">
            {{ translate("admin_payments.full_filter.without_payment_confirmation") }}
        </span>
        <span v-if="store.parameterId > 0" class="tag is-white">
            {{ store.selectedCategoryName }}
            <button class="delete" @click="removeSelectedCategory"></button>
        </span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import { handleError } from "../Common/errorHandler";
    import history from "../Common/history";
    import { useRegisteredCompetitorsStore } from "./registeredCompetitorsStore";

    const historyInstance = history.getInstance(window);
    const store = useRegisteredCompetitorsStore();

    const enabledAtLeastOneFilter = computed(() => {
        return (
            store.deleted ||
            store.onlyCompletePayments ||
            store.onlyMissingPayments ||
            store.showDisqualified ||
            store.parameterId > 0 ||
            store.paymentConfirmationFilter !== "all"
        );
    });

    function removeSelectedCategory(): void {
        store.parameterId = 0;
        historyInstance.setQueryParam("parameterId", null);
        store.offset = 0; // equivalent to resetOffset
        store.getRegisteredCompetitorsPage().catch(handleError);
    }
</script>

<style scoped></style>
